import transactionApi, { TransactionResponse } from "../../api/transaction/transactionApi";
import { useMutateApi } from "../hooks";

type UseAddTransactionParams = {
  onSuccess?: (data: any, variables: any) => void;
  onError?: (error: unknown) => void;
};
export const useAddTransaction = ({
  onSuccess,
  onError,
}: UseAddTransactionParams = {}) =>
  useMutateApi<TransactionResponse, any>({
    fetch: (variables) => transactionApi.addTransaction(variables),
    key: ["transactionApi.addTransaction"],
    onSuccess,
    onError,
  });